import { render } from "./Left.vue?vue&type=template&id=560950b5&scoped=true&ts=true"
import script from "./Left.vue?vue&type=script&lang=ts"
export * from "./Left.vue?vue&type=script&lang=ts"

import "./Left.vue?vue&type=style&index=0&id=560950b5&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560950b5"]])

export default __exports__